import {ApplicationConfig, isDevMode} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';

import {routes} from './app.routes';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {provideServiceWorker} from '@angular/service-worker';
import {authInterceptor} from './core/interceptors/auth-interceptor';
import {languageInterceptor} from './core/interceptors/language-interceptor';
import {loadingInterceptor} from './core/interceptors/loading-interceptor';
import {subscriptionErrorInterceptor} from './core/interceptors/subscription-error-interceptor';
import {permissionRecoveryInterceptor} from './core/interceptors/permission-recovery-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, languageInterceptor, loadingInterceptor, subscriptionErrorInterceptor, permissionRecoveryInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
  ],
};
